import { getBlock } from "../service/getBlock";
import { IProductImage } from "../views/ecommerce/products/interfaces";

export const getProductImage = async (
    productId: string, 
    setImageProduct: (images: IProductImage[]) => void
): Promise<{
    isError: boolean,
    block: any
}> => {
    const { block, isError } = await getBlock("/branch/products/photos", {
        productId: productId
    });

    setImageProduct(block.PhotosProduct)

    return {
        isError: isError,
        block: block
    }
}